import React from "react";
import { Dropdown, Tooltip } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import Stand from "components/stand";
import { EntityRemoveButton, Localize } from "components/service";
import { localizeByKey } from "components/service/localize";
import { TFlooring } from "components/flooring/helpers/flooring-types-helper";
import Icons from "components/icons";
import { usePermissionByObject } from "components/permissions";
import StandConst from "../stand-const";

interface IStandFlooringActionFieldProps
{
  flooring: TFlooring;
  standTypeGroup: string | undefined;
  variables: Record<string, any>
}

const StandFlooringActionField: React.FC<IStandFlooringActionFieldProps> = ({ flooring, standTypeGroup, variables }) =>
{
  // Permission hooks
  const { hasPermission: hasUpdatePermission } = usePermissionByObject(StandConst.permissions.UPDATE_FLOORING);
  const { hasPermission: hasDeletePermission } = usePermissionByObject(StandConst.permissions.DELETE_FLOORING);

  const { _setMutationFlooringRemove, loadingMutationFlooringRemove } =
    Stand.Hooks.flooringRemove();

  const { _setStandTypeFlooringUpdate } = Stand.Hooks.flooringUpdate(variables);

  const items = [
    {
      label: (
        <Tooltip
          title={!hasUpdatePermission ? `${localizeByKey('PERMISSION.Error_AccessDenied')}: ${localizeByKey(StandConst.permissions.UPDATE_FLOORING.slug)}` : undefined}
        >
          <span style={{ display: "flex", alignItems: "center", width: 100 }}>
            <Localize>MENUS_DROP.Label_MakeDefault</Localize>
          </span>
        </Tooltip>
      ),
      key: "1",
      icon: <Icons.Bookmark />,
      disabled: !hasUpdatePermission,
      onClick: () =>
      {
        if (!hasUpdatePermission) return;
        _setStandTypeFlooringUpdate({
          variables: {
            stand_type_group: standTypeGroup,
            flooring_id: flooring?.id,
          },
        });
      },
    },
    {
      key: "2",
      label: (
        <Tooltip
          title={!hasDeletePermission ? `${localizeByKey('PERMISSION.Error_AccessDenied')}: ${localizeByKey(StandConst.permissions.DELETE_FLOORING.slug)}` : undefined}
        >
          <EntityRemoveButton
            modalButton={
              <span style={{ display: "flex", alignItems: "center", width: 100 }}>
                <Icons.Delete /> <Localize>MENUS_DROP.Label_Delete</Localize>
              </span>
            }
            nameEntity={
              localizeByKey("ENTITY.Modal_Title_Flooring")
            }
            dataNameEntity={flooring?.title}
            loading={loadingMutationFlooringRemove}
            deleteMutation={(options) =>
            {
              if (!hasDeletePermission) {
                return Promise.reject(new Error('Access denied'));
              }
              return _setMutationFlooringRemove(options);
            }}
            variables={{
              flooring_id: flooring?.id,
              stand_type_group: standTypeGroup,
            }}
          />
        </Tooltip>
      ),
      disabled: !hasDeletePermission,
    },
  ];

  return (
    <Dropdown
      placement="bottomRight"
      menu={{ items }}
      overlayClassName="drop-more-menu"
      arrow
    >
      <EllipsisOutlined className="btn-more" />
    </Dropdown>
  );
};

export default StandFlooringActionField;